const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const fetchVideos = async () => {
    try {
        const resp = await fetch(`${SERVER_URL}/courses`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        if (resp.ok) {
            const data = await resp.json();
            return data;
        } else {
            throw new Error(`Error fetching videos: ${resp.status}`);

        }
    } catch(err) {
        throw err;
    }
}

// TODO: Implement this server-side
const fetchVideo = async ( videoID ) => {

    // Fetch list of all videos
    const videos = await fetchVideos();
    if (!videos) {
        throw new Error("Could not retrieve videos.")
    }

    // Loop through checking unique IDs
    for (let video of videos) {
        if (video.id === videoID) {
            return video
        }
    }

    // If we made it this far, the ID wasn't found
    throw new Error("No video found.")
}

const fetchSingAlongs = async () => {
    try {
        const resp = await fetch(`${SERVER_URL}/sing-alongs`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        if (resp.ok) {
            const data = await resp.json();
            return data;
        } else {
            throw new Error(`Error fetching sing-along videos: ${resp.status}`);

        }
    } catch(err) {
        throw err;
    }
}

const fetchSingAlongVideo = async (id) => {
    try {
        const resp = await fetch(`${SERVER_URL}/sing-alongs/${encodeURIComponent(id)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        if (resp.ok) {
            const data = await resp.json();
            return data;
        } else {
            // Use the server's error message
            const body = await resp.json().catch(() => null);
            throw new Error(body?.error ?? `Error fetching sing-along video with ID ${id}: ${resp.status}`);
        }
    } catch(err) {
        throw err;
    }
}

module.exports = { fetchVideos, fetchVideo, fetchSingAlongs, fetchSingAlongVideo };